// @flow
import * as React from 'react'
import LoadingSpinner from '../../LoadingSpinner'
import { useAppearance } from '../../../utils/withPalette'
import { StyledButton, ButtonText, LoadingContainer } from './elements'

// Types
export type Props = {
  TextWrapper?: any,
  size?: 'normal' | 'small' | 'large' | 'medium' | 'inherit',
  fullWidth?: boolean,
  color?: string,
  appearance?: 'general' | 'outlined' | 'flat' | 'bold' | 'link',
  loading?: boolean,
  disabled?: boolean,
  children?: any,
  innerRef?: Function,
  tabIndex?: any,
  type?: string,
}

/**
 * Flexible button component. Please do not add more
 * prop types and use only the existing ones. If you need
 * some really custom apperance just add another `appearance`
 * and implement it in CSS.
 * @param  {Object} props
 * @return {React.Element}
 */
const Button = ({
  TextWrapper,
  size,
  fullWidth,
  color,
  appearance,
  loading,
  tabIndex,
  type,
  innerRef,
  children,
  ...restProps
}: Props) => (
  <StyledButton
    {...restProps}
    ref={innerRef}
    $appearance={useAppearance('BUTTON', appearance)}
    $size={size}
    $fullWidth={fullWidth}
    $color={color}
    $loading={loading}
    tabIndex={tabIndex}
    type={type}
  >
    <ButtonText $as={TextWrapper}>{children}</ButtonText>
    {loading && (
      <LoadingContainer>
        <LoadingSpinner size="inherit" color="inherit" />
      </LoadingContainer>
    )}
  </StyledButton>
)

Button.defaultProps = {
  TextWrapper: 'span',
  fullWidth: false,
  color: 'primary',
  loading: false,
  tabIndex: '0',
  type: 'button',
}

export default Button
